import React from 'react';
import Chip, { ChipProps } from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import { IFärgKombo } from 'src/theme/NyttFärgtema';

export interface StyledChipNonFadeProps extends Omit<ChipProps, 'color'> {
    label: string;
    theme?: IFärgKombo;
    color?: string;
}

const StyledMuiChip = styled(Chip, {
    shouldForwardProp: (prop) => prop !== 'solidColor',
})<{ solidColor?: string }>(({ theme, solidColor }) => ({
    fontWeight: 600,
    fontSize: '13px',
    borderRadius: 6,
    height: 32,
    color: 'white',
    letterSpacing: '0.5px',
    border: 'none',
    background: solidColor || theme.palette.grey[700],
    '& .MuiChip-label': {
        paddingLeft: 12,
        paddingRight: 12,
    },
    '& .MuiChip-deleteIcon': {
        color: 'rgba(255, 255, 255, 0.7)',
        '&:hover': {
            color: 'white',
        },
    },
}));

export default function StyledChipNonFade({ label, theme, color, ...props }: StyledChipNonFadeProps) {
    const bgColor = color || (theme ? theme.primary.hexkod : undefined);

    return (
        <StyledMuiChip
            label={label}
            solidColor={bgColor}
            {...props}
        />
    );
}
